<template>
  <v-container id="shippingsummary">
    <v-row>
      <v-col sm="12" md="8">
        <v-sheet
          class="pa-3 elevation-1"
          style="white-space: pre-line"
          min-height="100%"
        >
          <div class="headline font-weight-bold">Addressing Info</div>
          {{ shipment.shipto }}
          {{ shipment.address }}
          {{ shipment.phone }}
        </v-sheet>
      </v-col>
      <v-col sm="12" md="4">
        <v-sheet class="pa-3 elevation-1" min-height="100%">
          <div class="headline font-weight-bold">Tracking Info</div>
          <br />
          Shipped On: {{ shipment.ship_date }}
          <br />
          Tracking: {{ shipment.tracking }}
          <br />
          Notes: {{ shipment.notes }}
          <br />
          Account Number: {{ shipment.account_number }}
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ShippingItemTable
          :detailed="true"
          :loading="false"
          :items="shipment.children"
          :id="parseInt(id)"
        >
        </ShippingItemTable>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              <v-icon left>fas fa-blender</v-icon>
              Miscellaneous Materials
            </v-toolbar-title>
            <v-spacer />
            <ShippingMiscForm
              :ticketid="id"
              :is-edit="false"
            />
          </v-toolbar>
          <ShippingMiscTable
            :items="shipment.children_misc"
            :loading="false"
            :is-detailed="true"
            :id="id"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ShippingItemTable from "../../components/Shipping/ShippingItemTable";
import ShippingMiscTable from "../../components/Shipping/ShippingMiscTable";
import ShippingMiscForm from "../../components/Shipping/ShippingMiscForm";
export default {
  name: "ShippingSummary",
  components: { ShippingMiscForm, ShippingMiscTable, ShippingItemTable },
  props: {
    shipment: {
      type: Object,
      required: true,
      default: () => {}
    },
    id: {
      type: [Number, String],
      required: true
    }
  }
};
</script>
